export default "__VITE_ASSET__CFWEqVaN__"